
define('tpl!taoQtiItem/qtiCreator/editor/colorPicker/tpl/popup', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"color-picker-container sidebar-popup\">\n    <div class=\"sidebar-popup-title\">\n        <h3 style=\"font-size:13px;margin:0\"></h3>\n        <a class=\"closer\" href=\"#\"></a>\n    </div>\n    <div class=\"sidebar-popup-content\">\n        <div class=\"color-picker\"></div>\n        <input class=\"color-picker-input\" type=\"text\" value=\"#000000\">\n    </div>\n</div>\n";
  });
});

